import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Margin = styled.div`
  margin-bottom: -2rem;
  @media (min-width: ${breakpoints.lg}) {
    margin-top: -1rem;
    margin-bottom: 4rem;
  }

  > div > div {
    padding: 0 0.9375rem;
  }
`;
